import { Observable } from 'rxjs';

import type { PaymentProvider } from '../models/order/order.model';

export abstract class PaymentsApi {
  /** Подключённые у организации провайдеры; незнакомые сайту реализация отбрасывает. */
  abstract providers(): Observable<readonly PaymentProvider[]>;

  /** URL страницы оплаты провайдера; сумм здесь нет — их в ссылку кладёт сервер. */
  abstract checkoutLink(
    orderId: string,
    provider: PaymentProvider,
    returnUrl: string,
  ): Observable<string>;
}
